// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'

// if a radio's lo frequency is less than 95000
// and its high frequency is greater than 7100
// then this radio should be considered a 7090 radio.

const radioIs7090 = ({ loFrequency, hiFrequency }) => {
  const lo = castToFloat(loFrequency)
  const hi = castToFloat(hiFrequency)

  return (
    lo !== null && lo <= 95000 &&
    hi !== null && hi >= 71000
  )
}

export default radioIs7090
